import { BreakPointCondition, Shadow, useBreakpointIf, VStack } from '@genial/components';
import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';

import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { CustomerDetailStackParamList } from '../../../../../../routes/types';
import { customerRecommendedPortfoliosQuery } from '../../../../../../store/customerDetail/selector';
import { EmptyList } from '../EmptyList';
import { ErrorListing } from '../ErrorListing';
import { AssetLoadingCard } from '../shared/AssetLoadingCard';
import { ProductDistributionHeader } from '../shared/ProductDistributionHeader';

import { PortfolioCard } from './components/PortfolioCard';
import { emptyListProps } from './constants';

export const RecommendedPortfolios: React.FC = () => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'md');
  const route = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();

  const { data, loading, error, refresher } = useRecoilQuery(
    customerRecommendedPortfoliosQuery({ accountNumber: route.params.accountNumber })
  );

  const renderTable = () => {
    if (error) {
      return <ErrorListing handleReload={refresher} />;
    }

    if (loading) {
      return Array.from({ length: 5 }).map((_, index) => (
        <AssetLoadingCard key={index} index={index} />
      ));
    }

    if (!data?.portfolios?.length) {
      return <EmptyList {...emptyListProps} />;
    }

    return (
      <VStack space="stack.nano">
        {data.portfolios.map((portfolio, index) => {
          return (
            <PortfolioCard
              key={index}
              portfolio={portfolio}
              isMobile={isMobile}
              isTablet={isTablet}
            />
          );
        })}
      </VStack>
    );
  };

  return (
    <Shadow level={1} borderRadius="sm" my="inset.sm" paddingX="inline.xxxs" paddingY="inline.xxs">
      <VStack space="stack.xxs">
        <ProductDistributionHeader
          isLoading={loading}
          totalValue={data?.generalInformation?.totalValue || 0}
          products={data?.generalInformation?.portfoliosInvested || []}
          hasError={!!error}
          principalTitle="Carteiras Recomendadas"
          principalTitleProps={{ textTransform: 'capitalize' }}
        />
        {renderTable()}
      </VStack>
    </Shadow>
  );
};
